module.exports = __webpack_public_path__ + "img/20210906-1630898489944418.575b6403.jpg";